<template>
  <el-dialog
    :title="id ? '编辑主词' : '新增主词'"
    :visible.sync="visible"
    width="620px"
  >
    <el-form
      ref="formRefs"
      :model="form"
      :rules="rules"
      label-width="100px"
      size="small"
    >
      <el-form-item label="站点" prop="site_id">
        <el-select
          v-model="form.site_id"
          filterable
          placeholder="请选择站点"
          class="w-full"
          @change="onSiteChange"
        >
          <el-option
            v-for="item in siteOptions"
            :key="item.id"
            :label="`${item.name} - ${item.url}`"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="主词" prop="seed_keyword">
        <el-input
          v-model="form.seed_keyword"
          placeholder="请输入主词"
        ></el-input>
      </el-form-item>
      <el-form-item label="目标域名" prop="target_domain">
        <el-input
          v-model="form.target_domain"
          placeholder="请输入目标域名"
        ></el-input>
      </el-form-item>
      <el-form-item label="目标URL" prop="target_url">
        <el-input
          v-model="form.target_url"
          placeholder="可选，默认使用站点网址"
        ></el-input>
      </el-form-item>
      <el-form-item label="国家/地区">
        <div class="flex">
          <el-input
            v-model="form.location_name"
            placeholder="例如 United States"
            class="mr-8px"
          ></el-input>
          <el-input
            v-model="form.location_code"
            placeholder="地区代码"
            class="w-140px"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="语言" prop="language_code">
        <el-input v-model="form.language_code" placeholder="en"></el-input>
      </el-form-item>
      <el-form-item label="设备" prop="device">
        <el-radio-group v-model="form.device">
          <el-radio label="desktop">桌面端</el-radio>
          <el-radio label="mobile">移动端</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-switch
          v-model="form.status"
          :active-value="1"
          :inactive-value="0"
          active-text="正常"
          inactive-text="停用"
        ></el-switch>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button type="primary" size="small" :loading="loading" @click="onSave"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  apiSeoSeedAdd,
  apiSeoSeedDetail,
  apiSeoSeedEdit,
  apiSeoSiteOptions,
} from "@/api/seo";

const defaultForm = () => ({
  site_id: "",
  seed_keyword: "",
  target_domain: "",
  target_url: "",
  location_code: "",
  location_name: "United States",
  language_code: "en",
  device: "desktop",
  status: 1,
  remark: "",
});

export default {
  data() {
    return {
      id: 0,
      visible: false,
      loading: false,
      siteOptions: [],
      form: defaultForm(),
      rules: {
        site_id: [{ required: true, message: "请选择站点", trigger: "change" }],
        seed_keyword: [
          { required: true, message: "请输入主词", trigger: "blur" },
        ],
        target_domain: [
          { required: true, message: "请输入目标域名", trigger: "blur" },
        ],
        language_code: [
          { required: true, message: "请输入语言", trigger: "blur" },
        ],
        device: [{ required: true, message: "请选择设备", trigger: "change" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  methods: {
    openDialog(id) {
      this.id = id || 0;
      this.visible = true;
      this.form = defaultForm();
      this.$nextTick(() => {
        this.$refs.formRefs && this.$refs.formRefs.clearValidate();
      });
      this.getSiteOptions();
      if (this.id) {
        this.getDetail();
      }
    },
    getSiteOptions() {
      apiSeoSiteOptions().then((resp) => {
        this.siteOptions = resp || [];
      });
    },
    getDetail() {
      apiSeoSeedDetail({ id: this.id }).then((resp) => {
        this.form = {
          ...defaultForm(),
          ...resp,
          location_code: resp.location_code || "",
        };
      });
    },
    onSiteChange(siteId) {
      const site = this.siteOptions.find((item) => item.id === siteId);
      if (!site) return;
      this.form.target_url = site.url;
      this.form.target_domain = this.extractDomain(site.url);
    },
    extractDomain(url) {
      try {
        return new URL(url).hostname;
      } catch (e) {
        return String(url || "")
          .replace(/^https?:\/\//, "")
          .replace(/\/.*$/, "");
      }
    },
    onSave() {
      this.$refs.formRefs.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const request = this.id ? apiSeoSeedEdit : apiSeoSeedAdd;
        request({ ...this.form, id: this.id })
          .then(() => {
            this.$message({ type: "success", message: "保存成功" });
            this.visible = false;
            this.$emit("refresh");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>
